import { render, staticRenderFns } from "./RulesFilter.vue?vue&type=template&id=04c77c0d&scoped=true&"
import script from "./RulesFilter.vue?vue&type=script&lang=js&"
export * from "./RulesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c77c0d",
  null
  
)

export default component.exports